import platformBackendClient from '@backend-clients/platform-backend';
import platformServicesClient from '@backend-clients/platform-services';
import { retry } from '@utils/services';

export default {
  get: (cid, pid) => retry(() => new Promise((resolve, reject) => {
    platformBackendClient.get(`/api/dashboard/company/${cid}/project/${pid}`)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  }), 3, 500),
  filter: (cid, pid, query) => new Promise((resolve, reject) => {
    platformBackendClient.get(`/api/dashboard/company/${cid}/project/${pid}/filter`, { params: query })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  }),
  getJsonData: (cid, pid) => platformBackendClient.get(`/api/dashboard/company/${cid}/project/${pid}/json`),
  getMetadataXlsx: (pid) => platformServicesClient.get(`/api/v1/projects/${pid}/reports/maximo-report`, { responseType: 'blob' }),
};
